import React from 'react';
import { motion } from 'framer-motion';
import { InstagramIcon, PhoneIcon, PinIcon } from './icons/Icons';
import { ADDRESS, INSTAGRAM, INSTAGRAM_HREF, PHONE_DISPLAY, PHONE_HREF, HOUSECALL_WHATSAPP_HREF } from '../data/site';
import { useLanguage } from '../data/i18n';
export function Booking() {
  const {
    t
  } = useLanguage();
  return <section id="reserva" className="relative w-full bg-black py-24 sm:py-32" data-id="element-21" data-mp="26zj18gd35rrg">
      <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-22" data-mp="1t8nxfihg20uq">
        <motion.h2 initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="font-display text-6xl sm:text-8xl leading-[0.9] tracking-[0.04em] text-bone" data-id="element-23" data-mp="1y0fjpgtkhkf2">
          {t.booking.title}
        </motion.h2>

        <div className="mt-14 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-3" data-id="element-24" data-mp="1abd1o7v0tpk1">
          <a href="https://maps.google.com/?q=Av.+Arias+de+Velasco+13,+29601+Marbella" target="_blank" rel="noreferrer" className="group flex flex-col items-center gap-4 bg-black px-6 py-10 transition-colors hover:bg-white hover:text-black" data-id="element-25" data-mp="1f9ekqssg5ovi">
            <PinIcon className="w-6 h-6 text-white/70 group-hover:text-black" data-id="element-26" data-mp="20uy5ny6prk79" />
            <span className="font-sans text-[10px] uppercase tracking-[0.3em] text-ash group-hover:text-black/60" data-id="element-27" data-mp="1vxereya0n7fb">
              {t.booking.address}
            </span>
            <span className="font-body text-sm font-light text-white/80 group-hover:text-black" data-id="element-28" data-mp="137zg07efvciv">{ADDRESS}</span>
          </a>

          <a href={PHONE_HREF} target="_blank" rel="noreferrer" className="group flex flex-col items-center gap-4 bg-black px-6 py-10 transition-colors hover:bg-white hover:text-black" data-id="element-29" data-mp="1hxng55avw550">
            <PhoneIcon className="w-6 h-6 text-white/70 group-hover:text-black" data-id="element-30" data-mp="pdycl0cjl1c6" />
            <span className="font-sans text-[10px] uppercase tracking-[0.3em] text-ash group-hover:text-black/60" data-id="element-31" data-mp="kgy6ipfozyl2">
              {t.booking.phone}
            </span>
            <span className="font-body text-sm font-light text-white/80 group-hover:text-black" data-id="element-32" data-mp="2phiqqowu4dmr">{PHONE_DISPLAY}</span>
          </a>

          <a href={INSTAGRAM_HREF} target="_blank" rel="noreferrer" className="group flex flex-col items-center gap-4 bg-black px-6 py-10 transition-colors hover:bg-white hover:text-black" data-id="element-33" data-mp="2ua2f8gx28t6c">
            <InstagramIcon className="w-6 h-6 text-white/70 group-hover:text-black" data-id="element-34" data-mp="26j6hz49u55rp" />
            <span className="font-sans text-[10px] uppercase tracking-[0.3em] text-ash group-hover:text-black/60" data-id="element-35" data-mp="2aljkzkx76pks">
              {t.booking.instagram}
            </span>
            <span className="font-body text-sm font-light text-white/80 group-hover:text-black" data-id="element-36" data-mp="2fi9zi3tctd43">{INSTAGRAM}</span>
          </a>
        </div>

        <a href={HOUSECALL_WHATSAPP_HREF} target="_blank" rel="noreferrer" className="mt-14 inline-block bg-white px-12 py-5 font-sans text-[11px] uppercase tracking-[0.35em] text-black hover:bg-white/85 transition-colors" data-id="element-37" data-mp="3qz0ae08q2t41">
          {t.booking.cta}
        </a>

        <p className="mt-16 font-body text-base sm:text-lg font-light italic text-white/55" data-id="element-38" data-mp="3rcviafkn1tc9">
          {t.footer.quote}
        </p>
      </div>
    </section>;
}